import { getCookie } from '../core/utils.js';

var code = '',
    ccode = '';
    
export function checkChannelParams() {
  var channels = document.querySelectorAll('.cta-channel');
  if(channels.length > 0 ) { channelParams(channels); }
}

function channelParams(channels) {
  channels.forEach(function(channel) {
    var temp = channel.getAttribute('href');
    var suf = '';
    switch (true) {  
      case temp.includes('talenta.co'):  
        suf = 'T7H';  
        break;  
      case temp.includes('qontak.com'):  
        suf = 'Q4D';  
        break; 
      case temp.includes('klikpajak.id'):  
        suf = 'K5C';  
        break; 
      case temp.includes('mekarisign.com'):  
        suf = 'E4C';  
        break; 
      case temp.includes('expense.mekari.com'):  
        suf = 'X6G';  
        break; 
      case temp.includes('desty.mekari.com'):  
        suf = 'D6G';  
        break; 
      case temp.includes('officeless.mekari.com'):  
        suf = 'O6G';  
        break; 
      case temp.includes('univ.mekari.com'):  
        suf = 'U4C';  
        break; 
      case temp.includes('mekari.com'):  
        suf = 'M5H';  
        break;
    }  

    code = getCookie('waba_code') ?? '';
    ccode = getCookie('wabac_code') ?? '';

    var pageIdEl = document.querySelector('#page_id');
    var pageID = (pageIdEl && pageIdEl.value) ? pageIdEl.value : '';
    if(pageID) {
      temp = temp.replace('{{channel}}', suf + code + ccode + '-' + pageID);
      temp = temp.replace('%7B%channel%7D%7D', suf + code + ccode + '-' + pageID);
    } else {
      temp = temp.replace('{{channel}}', suf + code + ccode);
      temp = temp.replace('%7B%channel%7D%7D', suf + code + ccode);
    }

    channel.href = temp;
  });
}